import NoImageSectionCard from "../../../general/noImageSectionCard";
import Accordion from "../../../general/ui-blocks/elements/accordion";

export default function GeneralFAQs({additionalFAQs}) {

    return (
        <div id="applicationessentials"
             className="bg-gray-100 theme-dark bg-color bg-pattern-full-width bg-pattern _none mt-5 mb-5">
            <NoImageSectionCard
                title={<h2 className="mb-5 text-center text-7xl"><strong>Essential
                    Questions</strong></h2>} shouldRemovePatternWrap={true}/>

            {additionalFAQs}

            <Accordion title="What level of experience do I need?" blurb={<div>
                None. The program is designed for beginners as well as students with some experience. We’ll meet you
                where you are. Whether you’ve never written a line of code or already run a small business, your role
                will match your skills and push you to grow.
            </div>}/>

            <Accordion title="How updated is the content?" blurb={<div>
                This is a live program. Everything you learn is current to the real world. The Startup Trainer brings
                their own recent experience (including capital raised, product launches, user growth, etc), so you’re
                never learning outdated theory. The product concepts are vetted for market relevance, and the stack we
                use (Figma, GitHub, React, Notion, etc.) is exactly what professional teams rely on right now. If the
                startup landscape shifts tomorrow, the program shifts with it.
            </div>}/>

            <Accordion title="Can I work on my own idea instead of the one assigned by the Startup Trainer?"
                       blurb={<div>
                           The product you build is chosen by your Startup Trainer from a set of pre‑vetted concepts.
                           This ensures you’re working on something with real market potential and a clear path to
                           launch. If you have a strong idea of your own, you’re welcome to discuss it with your
                           trainer. They may incorporate it or help you explore it after the program.
                       </div>}/>
            <Accordion title="Do I need to know how to code?" blurb={<div>
                Not necessarily. Teams have roles in product, design, marketing, and engineering. You can join in a
                non‑technical role if that’s where your strengths lie. If you want to learn coding during the program,
                we’ll provide guidance and tools to get started.
            </div>}/>
            <Accordion title="Can I use this experience for school credit?" blurb={<div>
                You’ll need to check with your school. Some students have successfully arranged independent study
                credit. We’re happy to provide documentation to support your request.
            </div>}/>
            <Accordion title="Can I apply to multiple programs?" blurb={<div>
                Yes. You're welcome to apply to both the 14‑Day and 28‑Day programs, or to different cohorts. If you
                have a strong preference, we recommend applying early to your first choice, as spots are limited and
                filled on a rolling basis. If you're accepted into one program, you may still apply to the other, but
                space may be limited by then.
            </div>}/>
            <Accordion title="What happens if I don't get accepted?" blurb={<div>
                We encourage you to try again. Admission is competitive, and we simply can't accept every qualified
                applicant due to limited spots. If you're not accepted, you can request feedback to help strengthen a
                future application. You're welcome to reapply for a later cohort. When available, we also offer a
                waitlist option, join it to be considered if a spot opens up.
            </div>}/>
        </div>
    )
}